import React from 'react';
import { Edit, SimpleForm, TextInput, required, minLength } from 'react-admin';

export const RolesEdit: React.FC = () => {
  return (
    <Edit title='Editar Rol'>
      <SimpleForm>
        <TextInput source='id' label='ID del Rol' disabled />
        <TextInput
          source='name'
          label='Nombre del Rol'
          validate={[required(), minLength(2)]}
        />
      </SimpleForm>
    </Edit>
  );
};
